import $ from 'jquery';

export default class Excursion {
  constructor(element) {
    this.$element = $(element);
    this.modify();
  }

  modify() {
    this.$element.find('.node').each((i, node) => {
      const more = $('.read-more-text', node).text();
      $('.node-header a', node).append(`<span class="more"><span class="text">${more}</span></span>`);
    });
  }
}
